import React from 'react';
import styles from './alert-modal-content.module.css';

interface AlertModalContentProps {
  title: string;
  subtext?: string;
  icon?: React.ReactNode;
  action: React.ReactNode;
}

export const AlertModalContent: React.FC<AlertModalContentProps> = ({
  title,
  subtext,
  icon,
  action
}) => {
  return (
    <div className={styles.modalContent}>
      <div className={styles.modalHeader}>
        <div className={styles.modalHeading}>
          {icon}
          <h2 className={styles.modalTitle}>{title}</h2>
        </div>
        {subtext && <p className={styles.modalSubtext}>{subtext}</p>}
      </div>
      {action}
    </div>
  );
};
